import { useEffect, useState } from 'react';

import { PayloadState, parsePayloadFromURL, pushPayloadToHistory } from '../../url-utils/payload';

export const usePayload = () => {
  const [payload, setPayload] = useState<PayloadState>(parsePayloadFromURL());

  useEffect(() => {
    const onPopstate = () => {
      setPayload(parsePayloadFromURL());
    };
    window.addEventListener('popstate', onPopstate);
    return () => {
      window.removeEventListener('popstate', onPopstate);
    };
  }, []);

  return {
    ...payload,
    pushPayloadToHistory,
  };
};
